<template>
    <div class="inner-box">
        <!-- <div class="content-name">
            <h2 class="dp-ib">{{ routeName }}</h2>
        </div> -->
        <div class="search-area2">
            <div>
                <search-form ref="refSearchForm" :search="search" @searchChange="searchChange" />
            </div>
        </div>
        <!-- <button @click="next">{{$refs.step}}다음</button>
        <Step ref="steps" :active="nextIdx" :steps="steps"></Step> -->
        <tabs :tab="tab" :active-btn="active" @changeTab="changeTab" v-show="false"/>
        <component ref="cmpTab" v-bind:is="viewer" :custParam="custParam"/>

        <!--공통-->
        <input id="hddTemp"                 type="hidden" v-model="com.hddTemp" /><!--외부 정보를 전달하기 위한 임시 공간-->
        <input id="hddCustSelectable"       type="hidden" v-model="com.hddCustSelectable" />
        <input id="hddFocusControlId"       type="hidden" v-model="com.hddFocusControlId" />
        <input id="hddSelectedTabClientID"  type="hidden" v-model="com.hddSelectedTabClientID" />
        <input id="hddFocusControlClientId" type="hidden" v-model="com.hddFocusControlClientId" />
        <input id="hddCustFindControlId"    type="hidden" v-model="com.hddCustFindControlId" />
        <input id="hddBOUND_ID"             type="hidden" v-model="com.hddBoundId" />
        <input id="hddEditable"             type="hidden" v-model="com.hddEditable" />
        <input id="hddCALL_BOUND_ID"        type="hidden" v-model="com.hddCallBoundId" /><!--콜이입시의 바운드아이디(내부)-->
        
        <!--일반상담-->
        <input id="hddCALL_ID"             type="hidden" v-model="com.hddCallId" />
        <input id="hddCAT_ID_LEVEL"        type="hidden" v-model="com.hddCallIdLevel" />
        <input id="hddCallTab_MODEL_ID"    type="hidden" v-model="com.hddCallTabModelId" />
        <input id="hddCallTab_MAKER"       type="hidden" v-model="com.hddCallTabMaker" />
        <input id="hddCallTab_MODEL_GROUP" type="hidden" v-model="com.hddCallTabModelGroup" />
        <input id="hddCallTab_MODEL_CD"    type="hidden" v-model="com.hddCallTabModelCd" />
        <input id="hddCallTab_DEPT_ID"     type="hidden" v-model="com.hddCallTabDeptCd" />
        <input id="hddCallTab_CHARGE_ID"   type="hidden" v-model="com.hddCallTabChargeId" />
        <input id="hddCallTab_CALL_TYPE"   type="hidden" v-model="com.hddCallTabCallType" />

        <!--주문상담-->
        <input id="hddORDER_ID"            type="hidden" v-model="com.hddOrderId" />
        <input id="hddOrderTab_PAY_YN"     type="hidden" v-model="com.hddOrderTabPayYn" />
    </div>
</template>

<script>

/* TEST */
import Step from '@/components/elementUI/Step/index.vue';
//import Views from '@/components/AS/Step/index.vue';

/* 검색 폼 컴포넌트 */
import SearchForm from '@/components/AS/SearchForm/agentSearchForm.vue';
/* Tab 구분 컴포넌트 */
import tabs from '@/components/AS/Tabs/index.vue';
import recipt from '@/components/AS/Receipt/agentReceipt.vue';
import history from '@/components/AS/History/index.vue';

export default {
    name: 'AS접수',
    components: {Step, SearchForm, tabs, recipt, history},
    data() {
        return {
            drawer: false,
            direction: 'ttb',
            data: [],
            viewer: 'recipt',/** 활성화된 Tab */
            orgTab:[
                {tabId: 'recipt', tabName:'AS접수', tabCss:"btn btn-primary", tabNo:'0', tabShow: true},
                {tabId: 'history', tabName:'AS접수이력', tabCss:"btn btn-outline-primary", tabNo:'1', tabShow: true},/** 'btn btn-nonActive'버튼 비활성화 class */
            ],
            tab:[],
            search: {
                custNm: "",
                addr1: "",
                addr2: "",
                zipCd1: "",
                telNo: "",
                hpNo: "",
                boundTelNo: "",
                custId: "",
                custType: "",
                custGb: "1",
                codeNm: "",
                useType: "Y",
                inType: "", /** 유입경로 */
                inTypeVal: "" /** 유입경로 값*/
            },
            applySearchCondRecipt: false, /** 조회조건 적용여부 */
            com : {
                hddTemp: '',
                hddCustSelectable: '',   
                hddFocusControlId: '',   
                hddSelectedTabClientID: '',  
                hddFocusControlClientId: '',
                hddCustFindControlId: '',
                hddBoundId: '',         
                hddEditable: '',         
                hddCallBoundId: '0', /** 콜이입시의 바운드아이디(내부) */

                hddCallId: '',
                hddCallIdLevel: '',
                hddCallTabModelId: '',
                hddCallTabMaker: '',
                hddCallTabModelGroup: '',
                hddCallTabModelCd: '',
                hddCallTabDeptCd: '',
                hddCallTabChargeId: '',
                hddCallTabCallType: '',

                hddOrderId: '',
                hddOrderTabPayYn: ''
            },
            active: true,
            nextIdx: 1,
            steps: [{
                title: 'Step 1'
                ,description: ''
            },
            {
                title: 'Step 2'
                ,description: ''
            },
            {
                title: 'Step 3'
                ,description: ''
            }],
            grants: {},
            custParam:{},
            inType: '', /** 유입경로 */
            inTypeVal: '' /** 유입경로 값 */
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        getGrants() {
            const {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate} = this.$menu.getGrants();
            return {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate}
        }
    },
    created() {
        this.tab = _.cloneDeep(this.orgTab);

        this.$store.commit("setHeaderTitle", {
            headerComponentName: this.head,
            routeName: this.routeName,
            isMobile: this.$device.isMobile()
        });
    },
    beforeRouteLeave(to, from, next) {
        this.removeAllBizSession();
        
        next(); 
    },
    mounted() {

        this.grants = this.$menu.getGrants();

        const rqInboundTelNo = this.$route.query.InboundTelNo ? this.$route.query.InboundTelNo : '' // 전화가 인입됨
        const rqUserId = this.$route.query.UserId ? this.$route.query.UserId : '' // USER_ID
        const rqCALL_ID = this.$route.query.CALL_ID ? this.$route.query.CALL_ID : ''    // CALL_ID
        const rqAS_ID = this.$route.query.AS_ID ? this.$route.query.AS_ID : ''    // AS_ID
        const rqORDER_ID = this.$route.query.ORDER_ID ? this.$route.query.ORDER_ID : ''    // ORDER_ID
        const rqReservationId = this.$route.query.ReservationId ? this.$route.query.ReservationId : ''    // ReservationId
        const rqRequestId = this.$route.query.RequestId ? this.$route.query.RequestId : ''    // RequestId
        const rqCallbackId = this.$route.query.CallbackId ? this.$route.query.CallbackId : ''    // CallbackId

        this.inType = '' // 유입경로
        this.inTypeVal = ''
         
        this.search.inType = this.inType
        this.search.inTypeVal = this.inTypeVal

        this.search = {
            ...this.com,
            ...this.search
        }
        
        let vAccessYn = 'Y';
        if(this.$store.state.loginInfo.groupUId=='29'){
            if(this.$route.path != '/AgencyReg') {
                vAccessYn = 'N';
            }
               
        } else {
            if(this.$route.path !='/VisitCall') {
                vAccessYn = 'N';
            }
        }

        if(vAccessYn === 'N') {
            this.$swal({
                type: 'warning',
                text: `잘못된 페이지 접근입니다. 공지사항페이지로 이동합니다.`,
                showCancelButton: false,
                confirmButtonText: '예'
            }).then((result) => {
                if (result.value) {
                    this.$router.push({name: 'DocList' });
                }
            });
        }
        
        //this.save();
    },
    methods: {
        save() {
            

            // const vform = {
            //     orderOpt: 'DESC', // 정렬순서 ASC or DESC
            //     page: 1,
            //     totalPage: 9999,
            //     totalCount: 9999,
            //     curPage: 0,
            //     processTime : ''
            // };
            // this.$http.post("/mobile/asMng/agent/agentMain", vform).then(response => {
            //     console.log('test response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // const vform = {
            //     asId: 'AS2302000173'
            // };
            // this.$http.post("/mobile/asMng/agent/asDetail", vform).then(response => {
            //     console.log('test response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // 자재관리 > 보유자재 > 조회(T1) 
            // 자재관리 > 요청(입고)자재목록 > 조회(T3) 
            // 자재관리 > 반납자재목록 > 조회(T4) 
            // 자재관리 > 출고자재목록 > 조회(T5) 
            // const vform = {
            //     asAgentId : this.$store.state.loginInfo.asAgentId || '0',
            //     asId: '',   // 접수번호 : 조회조건
            //     itemCd: '0', // 자재코드 : 조회조건 <== 없을경우 0 대입
            //     itemNm: '', // 자재품명 : 조회조건
            //     useModelNm: '', // 표준모델 : 조회조건
            //     tab: 'T4' // 탭에 맞게 셋텅 : T1, T3, T4, T5
            // };
            // console.log('itemSearch vform : ', vform);
            // this.$http.post("/mobile/itemMng/itemSearch", vform).then(response => {
            //     console.log('test response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });


            // // 자재반납태그 출력
            // const vform = {
            //     asId: 'AS0908002873',   // 접수번호 : 조회조건
            //       itemId: 3799 
            // };
            // console.log('itemSearch vform : ', vform);
            // this.$http.post("/mobile/itemMng/retItemPrint", vform).then(response => {
            //     console.log('retItemPrint response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });


            // // 자재관리 > 보유자재 > 반납저장
            // const vform2 = [
            //     {
            //         productType: 'Item',
            //         outAsAgentId: this.$store.state.loginInfo.asAgentId || '0',
            //         outDt: '',
            //         outType: 'UseNoItem',
            //         itemId: 24610, //선택한 자재id
            //         goodQty: 1, // 반품수량
            //         outItemId: 0,
            //         recycleQty: 0,  
            //         badQty: 0,  
            //         inAsAgentId: 3,
            //         description: '',
            //         processTime : ''
            //     }
            // ];

            // this.$http.put("/mobile/itemMng/holdItem/save", vform2).then(response => {
            //     console.log('test response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // 자재관리 > 전체자재 > 조회
            // const vform = {
            //     maker: '',
            //     itemGroup: '',
            //     description: '',
            //     useModelNm: '',
            //     itemCd: '',
            //     itemNm: 'SECURDISK',
            //     asAgentId : this.$store.state.loginInfo.asAgentId || '0',
            //     sortType: '',
            //     page: 1,
            //     totalPage: 1000,
            //     totalCount: 1000,
            //     curPage: 0,
            //     processTime : ''
            // };
            // this.$http.post("/mobile/itemMng/totalItem/list", vform).then(response => {
            //     console.log('test totalItem response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // 자재관리 > 전체자재 > 요청
            // const vform = {
            //     productType: 'Item', // Item or Model
            //     requestType: 'HoldItem', // HoldItem or UseItem
            //     asId: '',
            //     requestAsAgentId: this.$store.state.loginInfo.asAgentId || '0',
            //     itemId: '11686', // 선택한 자재
            //     goodQty: '1', // 요청수량
            //     recycleQty: '0',
            //     badQty: '0',
            //     asAgentId : '3', // 본사(3) 고정
            //     memo: '' // 메모
            // };
            // this.$http.put("/mobile/itemMng/totalItem/save", vform).then(response => {
            //     console.log('test totalItem response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            
            // 자재관리 > 요청(입고)자재목록 > 삭제처리
            // const vform = {
            //     productType: 'Item', // Item or Model
            //     outItemRequestId: '-1' // 요청ID 
            // };
            // this.$http.put("/mobile/itemMng/reqItem/delete", vform).then(response => {
            //     console.log('test totalItem response.data' , response.data);
            // }).catch((e) => {

            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // // 자재관리 > 요청(입고)자재목록 > 도착확인
            // const vform = {
            //     productType: 'Item', // Item or Model
            //     outItemId: '0' // 출고요청ID
            // };
            // this.$http.put("/mobile/itemMng/reqItem/saveConfirm", vform).then(response => {
            //     console.log('test totalItem response.data' , response.data);
            // }).catch((e) => {
                
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // // 자재관리 > 반납자재목록 > 삭제처리
            // const vform = {
            //     productType: 'Item', // Item or Model
            //     outItemId: '0' // 출고요청ID
            // };
            // this.$http.put("/mobile/itemMng/returnItem/delete", vform).then(response => {
            //     console.log('test totalItem response.data' , response.data);
            // }).catch((e) => {
                
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // 자재관리 > 출고자재등록 > 출고확정
            // const vform2 = {
            //         productType: 'Item',
            //         outItemId: 24610,   //선택한 자재id
                    
            //     };

            // this.$http.put("/mobile/itemMng/outItem/fixDelivery", vform2).then(response => {
            //     console.log('test response.data' , response.data);
            // }).finally(() => {
            //     this.$store.commit('finish')
            // });

            // 기술정보 게시판    
            // this.$http.post(`/api/boardMng/list`,{
            //     companyId: this.$store.state.loginInfo.compCd,
            //     srcId1: 'Home',
            //     srcId2: 'Notice',
            //     srcId3: "",
            //     srcId4: "",
            //     searchType: 'ModelNm', // 모델명: ModelNm, 제목,내용: TitleContent
            //     searchTxt: '', // 모델명, 제목, 내용의 텍스트
            //     startDt: '1900-01-01',
            //     endDt: '2100-01-01',
            //     asAgentId: this.$store.state.loginInfo.asAgentId || '0',
            //     importance: 'Importance',
            //     sortType : true,
            //     page : 1,
            //     totalPage : 9999,
            //     totalCount : 9999,
            //     curPage : 0,
            //     processTime : ""
            // })
            // .then(response => {
             
            //     console.log('게시판 : ', response.data)
            // }).finally(() => {
            
            // });
        },
        changeTab(params) {
            this.viewer = params.tabId;
        },
        clearReceiptTab(){
            // AS접수tab 초기화
            if(this.viewer === 'recipt') {
                // console.log('========clear :::', this.$refs.cmpTab)
                this.$refs.cmpTab.data = [];
                this.$refs.cmpTab.subData = [];
                this.$refs.cmpTab.form.callMemo = '';  /** 고객요구사항 */
                this.$refs.cmpTab.form.visitMemo = '';  /** 특이사항 */
                this.$refs.cmpTab.form.areaAgent = '';  /** 지역ID */
                this.$refs.cmpTab.form.asAgentId = '';  /** 처리센터 ID */
                this.$refs.cmpTab.form.asAgentNm = '';  /** 처리센터 */
                this.$refs.cmpTab.form.userNm = '';  /**처리기사 */
                this.$refs.cmpTab.form.userId = '';  /**처리기사 */
                this.$refs.cmpTab.form.allocationDt = '';  /** 배정일시 */
                this.$refs.cmpTab.form.tripGrade = '';  /** 출장급지 */
                this.$refs.cmpTab.form.custNm = '';  /** 신고자명 */
                this.$refs.cmpTab.form.telNo = '';  /** 신고자 전화번호 */
                this.$refs.cmpTab.form.requestVisitDt = '';  //this.$moment().format('YYYY-MM-DD'), /** 요청일시 : 처리기사 팝업에서 지정한 날짜 */
                this.$refs.cmpTab.form.requestVistHh = ''; /** 요청일시 시간 */
                this.$refs.cmpTab.form.requestVistMm = ''; /** 요청일시 분 */
            }
            
        },
        searchContentInTab(param){
            /**
             * 현재 뷰내의 자식콤포넌트인 SearchForm에서 DB데이타를 조회하여
             *  활성화된 자식콤포넌트(recipt, history)의 data에 값을 셋팅처리
             */

            // AS접수이력 조회
            console.log('AS접수이력 Call : searchContentInTab:' , param.callAsCustSelPageList)
            console.log('AS접수이력 Call : searchContentInTab this.viewer:' , this.viewer)
            // history.data = param || []
            // history.methods.proc()
            
            // this.histList = param.callAsCustSelPageList || []
            // this.custInfo = param.callCustSelItemList || {}
            console.log(' cmpTab ref: ', this.$refs.cmpTab)
            this.custParam = {
                ...param,
                ...this.com,
                inType : this.inType,
                inTypeVal: this.inTypeVal
             } || {}

            this.$refs.cmpTab.setHistoryList(param.callAsCustSelPageList || [])
            

            
        },
        handleClose(done) {
            this.$confirm('Are you sure you want to close this?')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        next() {
            console.log('AsMng next() start')
            if (this.nextIdx++ > this.steps.length-1) {
                this.nextIdx = 1;
            }
            //console.log(this.$refs.steps.$refs)
            if(this.nextIdx === 1) {
                console.log(`step1`,this.$refs.steps.$refs.step3)
            } else if(this.nextIdx === 2) {
                console.log(`step2`, this.$refs.steps.$refs.step1)
            } else if(this.nextIdx === 3) {
                console.log(`step3`, this.$refs.steps.$refs.step2)
            }
            return this.nextIdx;
        },
        removeAllBizSession() {
            // 각 Tab내의 세션정보 초기화

            sessionStorage.removeItem("asReceipt");      // AS접수제품 초기화
            sessionStorage.removeItem("asModelBreak");   // 고장증상 초기화
        },
        searchChange(param){
            console.log('search called: ', param);
            let vOnlySearch = _.cloneDeep(param);
            
            delete vOnlySearch.asAgentId;
            delete vOnlySearch.asAgentNm;
            delete vOnlySearch.areaAgent;
            delete vOnlySearch.userId;
            delete vOnlySearch.userNm;

            console.log('search called vOnlySearch: ', vOnlySearch);
            this.search = {
                    ...this.search,
                    ...vOnlySearch
                };
            
                // 대행사의 경우 하드코딩으로 변경되어서 아래로직 적용안함.
            // if(this.viewer === 'recipt' && this.$store.state.loginInfo.groupUId=='29') {
            //     if(param && param.asAgentId){
            //         this.$refs.cmpTab.form.areaAgent = param.areaAgent;  /** 지역ID */
            //         this.$refs.cmpTab.form.asAgentId = param.asAgentId;  /** 처리센터 ID */
            //         this.$refs.cmpTab.form.asAgentNm = param.asAgentNm;  /** 처리센터 */
            //         this.$refs.cmpTab.form.userId = param.userId;  /** 처리기사 */
            //         this.$refs.cmpTab.form.userNm = param.userNm;  /** 처리기사 */
            //     } else {
            //         this.$refs.cmpTab.form.areaAgent = '';  /** 지역ID */
            //         this.$refs.cmpTab.form.asAgentId = '';  /** 처리센터 ID */
            //         this.$refs.cmpTab.form.asAgentNm = '';  /** 처리센터 */
            //         this.$refs.cmpTab.form.userId = '';  /** 처리기사 */
            //         this.$refs.cmpTab.form.userNm = '';  /** 처리기사 */
            //     }
            // }
 
        }
    }
}
</script>